import React, { Fragment } from 'react'

const BackEndDev = () => {
    return (
        <Fragment>
            <h2>Back End Development</h2>
            <p>
                Sometimes your web application requires that we put in a server
                to facilitate different aspects. Our expertise in putting
                together REST APIs & Graph APIs will allow you to expand your
                online profitability by allowing users to stay in one place
                instead of leaving your site to gain access to more tools.
            </p>
        </Fragment>
    )
}

export default BackEndDev
